module.exports = __webpack_public_path__ + "img/signUpBtnBg3.55b2108e.png";